import script from "./GanttChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GanttChart.vue?vue&type=script&setup=true&lang=js"

import "./GanttChart.vue?vue&type=style&index=0&id=b162cc84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b162cc84"]])

export default __exports__